<template>
  <article class="feedback">
    <Form class="feedback__form" form-id="episode_feedback" :prefilled-inputs="prefilledInputs" />
  </article>
</template>

<script setup lang="ts">
const route = useRoute()

const prefilledInputs = computed(() => {
  const inputs: InputPrefill[] = []

  const { episode, show } = route.query

  if (episode) {
    inputs.push({
      key: 'sendungsausgabe',
      value: episode.toString()
    })
  }

  if (show) {
    inputs.push({
      key: 'sendung',
      value: show.toString()
    })
  }

  return inputs
})

</script>

<style lang="scss">
@use '~/assets/sass/tools';

.feedback {
  @include tools.grid;
  &__form {
    @include tools.page-grid-columns;
  }
}
</style>
